module.exports = __webpack_public_path__ + "img/extensionAndVideo.2cd0434c.svg";